import type { ApplyFiltersProps } from '../types/applyFilterProps'

export const applyFilterNew: ApplyFiltersProps = (
  { minAbsolutePrice, maxAbsolutePrice, minPriceSelected, maxPriceSelected },
  selectedFacetsFilter,
  setSelectedFacets
) => {
  const priceFilter =
    minPriceSelected === undefined && maxPriceSelected === undefined
      ? null
      : {
          key: 'price',
          value: `${minPriceSelected ?? minAbsolutePrice}-to-${
            maxPriceSelected ?? maxAbsolutePrice
          }`,
        }

  const newFacets = !priceFilter
    ? selectedFacetsFilter
    : [...selectedFacetsFilter, priceFilter]

  setSelectedFacets?.([...newFacets])
}
